<div class="row" *ngIf="widgetType">
  <div class="col-lg-9">
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group input-group-sm">
          <label>Name</label>
          <input
            type="text"
            placeholder="name"
            class="form-control"
            [(ngModel)]="w.name"
          />
        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group input-group-sm">
          <label>Refresh (s)</label>
          <input
            min="60"
            type="text"
            placeholder="refresh interval"
            class="form-control"
            [(ngModel)]="w.refreshInterval"
          />
        </div>
      </div>
      <div class="col-lg-5">
        <div class="form-group input-group-sm">
          <label>Period</label>
          <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group input-group-sm">
          <label>Min Height</label>
          <input
            min="60"
            type="text"
            placeholder="min height"
            class="form-control"
            [(ngModel)]="w.minHeight"/>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group input-group-sm">
          <label>Widget Size</label>
          <select [(ngModel)]="w.size" class="input-group form-select">
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="row">
      <div class="col-lg-12">
        <div class="form-group input-group-sm mb-3">
          <label>Text Size</label>
          <select [(ngModel)]="w.textSize" class="input-group form-select">
            <option value="text-small">Small</option>
            <option value="text-medium">Medium</option>
            <option value="text-large">Large</option>
          </select>
        </div>    
        <div class="form-group input-group-sm">
            <input type="checkbox" [(ngModel)]="widget.showTitle" /> Show Title
        </div>
        <div class="form-group input-group-sm">
          <input type="checkbox" [(ngModel)]="widget.showChart" /> Show Chart
        </div>
        <div class="form-group input-group-sm">
          <input type="checkbox" [(ngModel)]="widget.showValue" /> Show Value
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-3 mt-3">
  <div class="col-lg-3">
    <button
      (click)="addTimeSeries()"
      class="btn btn-primary btn-block"
      type="submit">
      <i class="fa fa-line-chart"></i> Add Control Series
    </button>
  </div>
</div>
<div class="row">
  <div class="col-lg-12">
    <tabset>
      <tab
        *ngFor="let tab of w.detailList"
        [heading]="tab.uri == null ? 'Not Set' : tab.displayName == '' || tab.displayName == null ? tab.uri : tab.displayName"
        [active]="tab.active"
        (select)="tab.active = true"
        (deselect)="tab.active = false"
        [disabled]="tab.disabled"
        [removable]="tab.removable"
        (removed)="removeTimeSeries(tab)">
        <div class="row">
          <div class="col-lg-4">
            <div class="row mt-3">
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Select Control Series</label>
                  <app-uri-select [customerId]="dashboard.customerId" [timeSeriesDetail]="tab" [enableMediaSearch]="false" [enableTagMatch]="true" [siteTypeCode]="dashboard.siteType" [siteUri]="siteUri"></app-uri-select>
                  <!--<app-time-series-select [timeSeriesDetail]="tab" [enableTagMatch]="true"></app-time-series-select>-->
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Site URI</label>
                  <input type="text" size="20" [(ngModel)]="tab.siteUri" class="form-control">
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Display Name</label>
                  <input type="text" size="20" [(ngModel)]="tab.displayName" class="form-control">
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group input-group-sm">
                  <label>Control Type {{tab.controlType}}</label>
                  <select [(ngModel)]="tab.controlType" class="input-group form-select">
                    <option value="0">Switch</option>
                    <option value="1">Button</option>
                    <option value="2">Slider</option>
                    <option value="3">PTZ</option>
                  </select>
                </div>
              </div>

              
             
            </div>
            
          </div>
          <div class="col-lg-4">
            
            <!-- start slider -->
            <div class="col-lg-12" *ngIf="tab.controlType == 2">
              <div class="form-group input-group-sm">
                <label>Slider Min</label>
                <input type="number" size="20" [(ngModel)]="tab.sliderMin" class="form-control">
              </div>
            </div>
            <div class="col-lg-12" *ngIf="tab.controlType == 2">
              <div class="form-group input-group-sm">
                <label>Slider Max</label>
                <input type="number" size="20" [(ngModel)]="tab.sliderMax" class="form-control">
              </div>
            </div>
            <div class="col-lg-12" *ngIf="tab.controlType == 2">
              <div class="form-group input-group-sm">
                <label>Slider Step</label>
                <input type="number" size="20" [(ngModel)]="tab.sliderStep" class="form-control">
              </div>
            </div>

            <!-- start switch -->              
            <div class="col-lg-12" *ngIf="tab.controlType == 0">
              <div class="form-group input-group-sm">
                <label>Switch On / Value</label>
                <div class="input-group">
                  <input type="string" size="20" [(ngModel)]="tab.switchOn" class="form-control">
                  <input type="number" size="20" [(ngModel)]="tab.switchOnValue" class="form-control">
                </div>  
              </div>
            </div>
            <div class="col-lg-12" *ngIf="tab.controlType == 0">
              <div class="form-group input-group-sm">
                <label>Switch Off</label>
                <div class="input-group">
                  <input type="string" size="20" [(ngModel)]="tab.switchOff" class="form-control">
                  <input type="number" size="20" [(ngModel)]="tab.switchOffValue" class="form-control">
                </div>
              </div>
            </div>

             <!-- start button -->              
             <div class="col-lg-12" *ngIf="tab.controlType == 1">
              <div class="form-group input-group-sm">
                <label>Button Value</label>
                <input type="string" size="20" [(ngModel)]="tab.buttonValue" class="form-control">
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-lg-12">
              <div class="form-group input-group-sm">
                <app-transform-editor [transforms]="tab.transforms"></app-transform-editor>
              </div>
            </div>
          </div>
        </div>        
      </tab>
    </tabset>
  </div>
</div>
